import { omit } from "lodash";
import { useDropzone } from "react-dropzone";
import { useFormContext } from "react-hook-form";
import { MIME_TYPE } from "common/constants";
import { spacing } from "../../../../../stitches.config";
import { Section, Sections } from "../../../../Common/Layout";
import { HeaderRowComponent } from "../../../../FileUploads";
import { SingleFileUpload, Text } from "../../../../Inputs/react-hook-form";
import { ConfigStageWrapper } from "./__styles__/ParcelImportWizard";
import { GpkgImportWizardFormData } from "./types";

const GpkgParcelImportConfigStage = () => {
  const {
    control,
    formState: { errors },
    register,
  } = useFormContext<GpkgImportWizardFormData>();

  return (
    <ConfigStageWrapper>
      <Sections gap={spacing.m}>
        <Section>
          <Text
            label="Name"
            error={errors.name?.message}
            required
            {...register("name", {
              required: "Name is required",
            })}
          />
        </Section>
        <Section>
          {/* this wrapping div is needed to keep the section spacing from mucking with the
          file upload component, which is a fragment with no container */}
          <div>
            <SingleFileUpload<any, "geopackageUpload">
              {...omit(register("geopackageUpload"), "ref")}
              control={control}
              useDropzone={useDropzone}
              label={"Import File"}
              description={"File must be a geopackage (.gpkg) file"}
              required
              allowedMimeTypes={[MIME_TYPE.GPKG]}
              fileHeader={
                <HeaderRowComponent hasGreenCheckmark={true}>
                  <div tabIndex={0}>File name</div>
                </HeaderRowComponent>
              }
            />
          </div>
        </Section>
      </Sections>
    </ConfigStageWrapper>
  );
};

export default GpkgParcelImportConfigStage;
